<template>
    <nav role="navigation">
        <div class="d-lg-none">
            <!-- Mobile Version -->
            <b-button
                v-b-toggle.nav-sidebar
                variant="dark"
                class="mb-4"
                size="lg"
            >
                <b-icon-arrow-bar-right/> Navegación
            </b-button>

            <b-sidebar
                id="nav-sidebar"
                title="Navegación"
                backdrop-variant="dark"
                backdrop
                shadow
                lazy
            >
                <b-nav pills vertical>
                    <b-nav-item
                        :to="{ name: 'site-general-info' }"
                        exact
                        exact-active-class="active"
                    >
                        Información General
                    </b-nav-item>

                    <b-nav-item
                        :to="{ name: 'site-thematic-content' }"
                        exact
                        exact-active-class="active"
                    >
                        Contenido Temático
                    </b-nav-item>

                    <b-nav-item
                        :to="{ name: 'site-teachers-staff' }"
                        exact
                        exact-active-class="active"
                    >
                        Grupo Docente
                    </b-nav-item>

                    <b-nav-item
                        :to="{ name: 'site-timetables' }"
                        exact
                        exact-active-class="active"
                    >
                        Horarios
                    </b-nav-item>

                    <b-nav-item
                        v-if="isUserStudenTeacherOrBetter"
                        :to="{ name: 'site-students' }"
                        exact
                        exact-active-class="active"
                    >
                        Estudiantes
                    </b-nav-item>

                    <b-nav-item
                        :to="{ name: 'site-evaluations' }"
                        exact
                        exact-active-class="active"
                    >
                        Evaluaciones
                    </b-nav-item>

                    <b-nav-item
                        v-if="isUserStudentOrBetter"
                        :to="surveyRoute"
                        exact
                        exact-active-class="active"
                    >
                        Encuestas/Quices
                    </b-nav-item>

                    <b-nav-item
                        v-if="isUserStudentOrBetter"
                        :to="{ name: 'site-assignments' }"
                        exact
                        exact-active-class="active"
                    >
                        Entregas
                    </b-nav-item>

                    <b-nav-item
                        :to="{ name: 'site-scheduling' }"
                        exact
                        exact-active-class="active"
                    >
                        Planificación
                    </b-nav-item>

                    <b-nav-item
                        v-if="isUserStudentOrBetter"
                        :to="{ name: 'site-grades' }"
                        exact
                        exact-active-class="active"
                    >
                        Calificaciones
                    </b-nav-item>

                    <b-nav-item
                        :to="{ name: 'site-news' }"
                        exact
                        exact-active-class="active"
                    >
                        Noticias
                    </b-nav-item>

                    <b-nav-item
                        v-if="isUserStudentOrBetter"
                        :to="{ name: 'site-forums' }"
                        exact
                        exact-active-class="active"
                    >
                        Foros
                    </b-nav-item>

                    <b-nav-item
                        :to="{ name: 'site-downloads' }"
                        exact
                        exact-active-class="active"
                    >
                        Descargas
                    </b-nav-item>

                    <b-nav-item
                        v-if="isUserStudenTeacherOrBetter"
                        :to="{ name: 'site-send-email' }"
                        exact
                        exact-active-class="active"
                    >
                        Enviar Correo
                    </b-nav-item>

                    <b-nav-item
                        v-if="isUserCoordOrBetter"
                        :to="{ name: 'site-logs' }"
                        exact
                        exact-active-class="active"
                    >
                        Registro de Actividades
                    </b-nav-item>

                    <b-nav-item
                        :to="{ name: 'site-previous-semesters' }"
                        exact
                        exact-active-class="active"
                    >
                        Semestres Anteriores
                    </b-nav-item>

                </b-nav>
            </b-sidebar>
        </div>
        <b-nav pills vertical class="d-none d-lg-block">
            <b-nav-item
                :to="{ name: 'site-general-info' }"
                exact
                exact-active-class="active"
            >
                Información General
            </b-nav-item>

            <b-nav-item
                :to="{ name: 'site-thematic-content' }"
                exact
                exact-active-class="active"
            >
                Contenido Temático
            </b-nav-item>

            <b-nav-item
                :to="{ name: 'site-teachers-staff' }"
                exact
                exact-active-class="active"
            >
                Grupo Docente
            </b-nav-item>

            <b-nav-item
                :to="{ name: 'site-timetables' }"
                exact
                exact-active-class="active"
            >
                Horarios
            </b-nav-item>

            <b-nav-item
                v-if="isUserStudenTeacherOrBetter"
                :to="{ name: 'site-students' }"
                exact
                exact-active-class="active"
            >
                Estudiantes
            </b-nav-item>

            <b-nav-item
                :to="{ name: 'site-evaluations' }"
                exact
                exact-active-class="active"
            >
                Evaluaciones
            </b-nav-item>

            <b-nav-item
                v-if="isUserStudentOrBetter"
                :to="surveyRoute"
                exact
                exact-active-class="active"
            >
                Encuestas/Quices
            </b-nav-item>

            <b-nav-item
                v-if="isUserStudentOrBetter"
                :to="{ name: 'site-assignments' }"
                exact
                exact-active-class="active"
            >
                Entregas
            </b-nav-item>

            <b-nav-item
                :to="{ name: 'site-scheduling' }"
                exact
                exact-active-class="active"
            >
                Planificación
            </b-nav-item>

            <b-nav-item
                v-if="isUserStudentOrBetter"
                :to="{ name: 'site-grades' }"
                exact
                exact-active-class="active"
            >
                Calificaciones
            </b-nav-item>

            <b-nav-item
                :to="{ name: 'site-news' }"
                exact
                exact-active-class="active"
            >
                Noticias
            </b-nav-item>

            <b-nav-item
                v-if="isUserStudentOrBetter"
                :to="{ name: 'site-forums' }"
                exact
                exact-active-class="active"
            >
                Foros
            </b-nav-item>

            <b-nav-item
                :to="{ name: 'site-downloads' }"
                exact
                exact-active-class="active"
            >
                Descargas
            </b-nav-item>

            <b-nav-item
                v-if="isUserStudenTeacherOrBetter"
                :to="{ name: 'site-send-email' }"
                exact
                exact-active-class="active"
            >
                Enviar Correo
            </b-nav-item>

            <b-nav-item
                v-if="isUserCoordOrBetter"
                :to="{ name: 'site-logs' }"
                exact
                exact-active-class="active"
            >
                Registro de Actividades
            </b-nav-item>

            <b-nav-item
                :to="{ name: 'site-previous-semesters' }"
                exact
                exact-active-class="active"
            >
                Semestres Anteriores
            </b-nav-item>

        </b-nav>
    </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'SiteSidebarNav',
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'isUserCoordOrBetter',
            'isUserStudenTeacherOrBetter',
            'isUserStudentOrBetter'
        ]),
        surveyRoute () {
            if (this.isUserStudenTeacherOrBetter) {
                return { name: 'site-teacher-surveys' }
            } else {
                return { name: 'site-student-surveys' }
            }
        }
    }
}
</script>
